import { useState, useEffect } from 'react';

const usePagination = (items, itemsPerPage) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [paginatedItems, setPaginatedItems] = useState([]);
    const [prevItemsLength, setPrevItemsLength] = useState(items?.length || 0);

    const currentItemsLength = items?.length || 0;

    if (currentItemsLength !== prevItemsLength) {

        setPrevItemsLength(currentItemsLength);

        if (currentItemsLength < prevItemsLength) {
            setCurrentPage(1);
        } else if (
            currentItemsLength > prevItemsLength &&
            currentPage * itemsPerPage >= prevItemsLength
        ) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    }

    useEffect(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        setPaginatedItems(items?.slice(0, endIndex));
    }, [currentPage, items, itemsPerPage]);

    const loadMoreItems = () => {
        setCurrentPage((prevPage) => prevPage + 1);
    };

    return { paginatedItems, loadMoreItems };
};

export default usePagination;
